import axios from "axios";
import { API_BASE_URL } from "../utils/apiConfig";

export interface RegisterRequest {
  username: string;
  email: string;
  password: string;
  name?: string;
  phone?: string;
}

/**
 * Rejestracja nowego użytkownika (wymaga uprawnienia users.create).
 * POST /api/auth/register/
 */
export const register = async (data: RegisterRequest): Promise<void> => {
  await axios.post(`${API_BASE_URL}/auth/register/`, data);
};
